export default "__VITE_PUBLIC_ASSET__dce4f8c9__"